module.exports = __webpack_public_path__ + "static/media/user-circle.ce334f5f.svg";